<h2>
	Review & Submit
	<span
		class="validation-error"
		*ngIf="anyStepHasErrors()"
	>
		(missing required input)
	</span>
</h2>

<div class="container">
	<div
		class="no-steps-configured"
		*ngIf="stepsWithElements.length === 0"
	>
		At least one duty must be configured.
	</div>

	<div
		class="step"
		*ngFor="let step of stepsWithElements"
	>
		<div class="step-label">{{ step.stepLabel }} Summary</div>
		<div
			class="validated-element"
			*ngFor="let validatedElement of step.validatedElements"
		>
			<span [ngClass]="{ 'validation-error': validatedElement.error }">
				{{ validatedElement.label }}
			</span>
			: {{ validatedElement.value }}
			<div
				*ngIf="validatedElement.extraHtml"
				[innerHTML]="validatedElement.extraHtml(sanitizer)"
			></div>
		</div>
	</div>
</div>

<!-- Separator -->
<div class="separator"></div>

<!-- New copied controls -->
<form [formGroup]="form">
	<div class="form-group">
		<div class="rule-name-label">
			Rule name:
			<span class="required">*</span>
		</div>

		<app-missing-input [show]="showNameExistsError || ruleName?.errors?.['required']">
			<input
        cdkFocusInitial
				class="input want-error-border"
				formControlName="ruleName"
				placeholder="Rule Name"
				maxlength="25"
				matTooltip="Max length = 25"
				aria-label="Rule Name"
			/>
		</app-missing-input>
		<div
			class="error-message"
			[style]="'visibility:' + (showNameExistsError ? 'visible' : 'hidden')"
		>
			This rule name already exists
		</div>
	</div>

	<div class="vspace-16px"></div>

	<div class="form-group">
		<div
			class="validation-error" id="exclude-zone-warning"
			*ngIf="hasDupeZones"
		>Your excluded zones cannot include zones selected from the Duty Start/Duty End steps. Change your zone selections to enable saving this rule.</div>
    <button class="mat-button" id="exclude-zone-button" (click)="openZoneSelector()" type="button" tabindex="0">
			{{ title }}
			<mat-icon>arrow_drop_down</mat-icon>
		</button>

	</div>
</form>
